"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataEpoqObject = void 0;
const readCookies_1 = require("./readCookies");
function getDataEpoqObject(cartOrOrder, tenant) {
    const { demandwareCustomerId, demandwareSessionId, evelinCustomerId, evelinSessionId } = (0, readCookies_1.readCookies)(tenant);
    const items = cartOrOrder.items;
    const products = items
        .flatMap(item => {
        const mainProductInfo = [
            {
                productIds: item.product.title,
                quantities: item.quantity,
                unitPrices: item.product.price.gross.amount,
                productSKU: item.product.manufacturerSku,
            },
        ];
        const additionalProducts = [];
        if ('packaging' in item && item.packaging) {
            const packagingTitle = item.packaging.title;
            if (packagingTitle) {
                const packagingProductInfo = {
                    productIds: packagingTitle,
                    quantities: item.quantity,
                    unitPrices: item.packaging.price.gross.amount,
                    productSKU: item.packaging.manufacturerSku,
                };
                additionalProducts.push(packagingProductInfo);
            }
        }
        else if ('selectedPackaging' in item && item.selectedPackaging) {
            const packagingProductInfo = {
                productIds: item.selectedPackaging.title,
                quantities: item.quantity,
                unitPrices: item.selectedPackaging.price.gross.amount,
                productSKU: item.selectedPackaging.variantId,
            };
            additionalProducts.push(packagingProductInfo);
        }
        return [mainProductInfo, ...additionalProducts];
    })
        .flat();
    return {
        tenantId: 'jochen-schweizer',
        customerId: demandwareCustomerId,
        sessionId: demandwareSessionId,
        evelinCustomerId,
        evelinSessionId,
        products,
    };
}
exports.getDataEpoqObject = getDataEpoqObject;
//# sourceMappingURL=getDataEpoqObject.js.map